export default {
  title: 'Thanks!',
  subtitle:
    'Although all communication about the loan application will be sent directly to you, and not to your client, we hold the right to contact your client to confirm you have the authority to act on their behalf',
  phoneNumberLabel: 'Phone number',
  paragraph: 'What’s the best number to reach them on?',
  submitButton: 'Continue'
};
